import { Link } from "react-router-dom";
import { HelpCircle } from "lucide-react";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { useLanguage } from "@/hooks/useLanguage";

const FAQHero = () => {
  const { t, localizePath } = useLanguage();

  return (
    <section className="relative bg-secondary/30 pt-40 pb-16 overflow-hidden">
      <div className="absolute top-20 right-0 w-[400px] h-[400px] bg-accent/10 rounded-full blur-3xl -z-10" />

      <div className="container mx-auto px-4 md:px-6">
        <Breadcrumb className="mb-8">
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to={localizePath("/")} className="text-muted-foreground hover:text-accent">
                  {t("faqPage.home")}
                </Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage className="text-accent">{t("faqPage.breadcrumb")}</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>

        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 bg-accent/10 text-accent px-4 py-2 rounded-full text-sm font-medium mb-6">
            <HelpCircle className="w-4 h-4" />
            {t("faqPage.badge")}
          </div>

          <h1 className="text-4xl md:text-5xl font-bold text-primary mb-6">
            {t("faqPage.title")}
          </h1>

          <p className="text-lg text-muted-foreground">
            {t("faqPage.description")}
          </p>
        </div>
      </div>
    </section>
  );
};

export default FAQHero;
